import React from "react";
import { Box, Button, Snackbar, makeStyles } from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import Alert from "@material-ui/lab/Alert";
import FirebaseLogin from "./FirebaseLogin";
import palette from "../styles/palette";
import { OK } from "../../constants/strings";

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    container: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    errorContainer: {
      position: "relative",
      paddingTop: pxToRem(28),
      height: pxToRem(50),
    },
    error: {
      position: "inherit",
      bottom: 0,
    },
    alert: {
      backgroundColor: palette.slate,
      fontWeight: "normal",
      boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 1px 5px rgba(0, 0, 0, 0.2)`,
    },
    clearErrorMsgBtn: {
      color: palette.yellow,
      fontSize: pxToRem(14),
      lineHeight: pxToRem(20),
    },
  };
});

export default ({ error, onLogin, onCloseError }) => {
  const styles = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    onCloseError(false);
  };

  return (
    <Box className={styles.container}>
      <FirebaseLogin onClick={onLogin} />
      <Box className={styles.errorContainer}>
        <Snackbar open={error} className={styles.error} onClose={handleClose}>
          <Alert
            severity="warning"
            variant="filled"
            icon={<WarningRoundedIcon />}
            classes={{
              filledWarning: styles.alert,
            }}
            action={
              <Button
                className={styles.clearErrorMsgBtn}
                size="small"
                disableRipple
                onClick={handleClose}
              >
                {OK}
              </Button>
            }
          >
            {error}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};
